import {GetSafeValue} from "../utils/get-safe-value";
import {StringFieldUtil} from "../utils/string-field-util";
/**
 * Created by cheaphakdey on 11/7/19.
 */

export class BankPayment {
  private _accountName: string;
  private _accountNumber: string;
  private _bankName: string;
  private _transactionId: string;

  constructor(){
    this.accountNumber = "";
    this.accountName = "";
    this.bankName = "";
    this.transactionId = "";
  };

  clone(other: BankPayment) {
    this.accountName = other.accountName;
    this.accountNumber = other.accountNumber;
    this.bankName = other.bankName;
  }

  get accountName(): string {
    return this._accountName;
  }

  set accountName(value: string) {
    this._accountName = value;
  }

  get accountNumber(): string {
    return this._accountNumber;
  }

  set accountNumber(value: string) {
    this._accountNumber = value;
  }

  get bankName(): string {
    return this._bankName;
  }

  set bankName(value: string) {
    this._bankName = value;
  }

  get transactionId(): string {
    return this._transactionId;
  }

  set transactionId(value: string) {
    this._transactionId = value;
  }

  fromJson(data: BankPayment) {
    this.accountName = GetSafeValue.getSafeValueAsString(
      data[StringFieldUtil.accountName],
      ""
    );
    this.accountNumber = GetSafeValue.getSafeValueAsString(
      data[StringFieldUtil.accountNumber],
      ""
    );
    this.bankName = GetSafeValue.getSafeValueAsString(
      data[StringFieldUtil.bankName],
      ""
    );
  }

  toMap() {
    return {
      'accountName': this._accountName,
      'accountNumber': this._accountNumber,
      'bankName': this._bankName,
      'transactionId': this._transactionId,
    };
  }
}
